(function () {
    'use strict';

    angular
        .module('skillsApp')
        .controller('CreateClusterActionDialogController', CreateClusterActionDialogController);

    function CreateClusterActionDialogController(cluster, logger, config, $q, $uibModalInstance, $translate, dataService) {
        var vm = this;
        
        vm.cluster = cluster;
        vm.clusterType = dataService.getClusterTypes(vm.cluster.clusterType);
        vm.validity = 12;
        vm.onlyAssignToFunctions = config.settings.onlyAssignToFunctions;
        vm.validityEditable = true;
        vm.trainingGroupsEditable = false;

        vm.cancel = cancel;
        vm.save = save;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

        function save(formData, addActivities) {
            if (!formData.$valid) return $q.reject();
                
            var clusterAction = {
                actionName: vm.actionName,
                clusterType: vm.cluster.clusterType,
                clusterId: vm.cluster.id,
                clusterName: vm.cluster.name,
                validity: vm.validity,
                validityNotEditable: !vm.validityEditable,
                trainingGroupsEditable: vm.trainingGroupsEditable
            };
                
            return dataService.saveClusterAction(clusterAction)
                .then(result => {
                    logger.success('successfully_saved');
                    clusterAction.id = result.item.id;
                    $uibModalInstance.close({ clusterAction: clusterAction, addActivities: addActivities });
                });
        }
    }
})();
